import { createContext } from '@chakra-ui/react-utils';
import { forwardRef } from '@chakra-ui/react-v2';
import { type HTMLChakraProps, chakra } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { type ThemeSpace } from '@frontend/legacy-components';

import type { TagProps } from './';
import { DEFAULT_PROPS } from './const';
import type { TagSize } from './types';

export const TAG_GROUP_GAPS = {
  xs: 0.25,
  sm: 0.5,
} as const satisfies Record<TagSize, ThemeSpace>;

export type TagGroupProps = Pick<TagProps, 'size'> & HTMLChakraProps<'div'>;
export const [TagGroupProvider, useTagGroup] = createContext<TagGroupProps>({
  name: 'TagGroupContext',
  strict: false,
});

export const TagGroup = forwardRef<TagGroupProps, 'div'>(
  ({ size, children, className, ...restProps }, ref) => {
    const defaultedSize = size ?? DEFAULT_PROPS.size;

    return (
      <chakra.div
        className={cx('tag-group', className)}
        role="group"
        ref={ref}
        display="flex"
        flexFlow="row wrap"
        gap={TAG_GROUP_GAPS[defaultedSize]}
        {...restProps}
      >
        <TagGroupProvider value={{ size: defaultedSize }}>
          {children}
        </TagGroupProvider>
      </chakra.div>
    );
  },
);
TagGroup.displayName = 'TagGroup';
